import {Text} from '@dropbox/dig-components/typography';
import {Stack} from '@dropbox/dig-foundations';

import {Panel} from './Panel';

/** A headline number with a label above and a short note below. */
export const StatTile = ({label, value, note}: {label: string; value: string; note: string}) => (
  <Panel>
    <Stack gap="4">
      <Text tagName="div" size="small" color="subtle">
        {label}
      </Text>
      <Text tagName="div" size="xlarge" isBold>
        {value}
      </Text>
      <Text tagName="div" size="small" color="subtle">
        {note}
      </Text>
    </Stack>
  </Panel>
);
